globalThis.masterBackoffice = globalThis.masterBackoffice || {};

masterBackoffice.ClipsedNav = (function()
{
  function ClipsedNav($html) {
    if($html.length === 1)
    {
      this.$html    = $html;
      this.$btn     = this.$html.find('.toggle-nav');
      this.$content = $('.main-container');
      this.$footer  = $('.main-container footer');
      this.widthNav = {
        'clipsed'   : '40px',
        'unclipsed' : '170px'
      };

      this.init();
    }
  }

  ClipsedNav.prototype = {
    _events: function(){
      var me = this;
      this.$btn.on('click', function(){
        me.$html.hasClass('clipsed') ? me._unclips() : me._clips();
      });

    },
    _clips: function(){
      this.$html.addClass('clipsed')
                .removeClass('unclipsed')
                .css({
                  width : this.widthNav['clipsed']
                });
      this.$html.find('span.text').hide();
      this.$content.css('left', this.widthNav['clipsed']);
      this.$footer.css('left', this.widthNav['clipsed']);
      this.$btn.find('span').removeClass('glyphicon-triangle-left')
                            .addClass('glyphicon-triangle-right');

      this._tooltip(true);
    },
    _unclips: function(){
      this.$html.addClass('unclipsed')
                .removeClass('clipsed')
                .css({
                  width : this.widthNav['unclipsed']
                });
      this.$html.find('span.text').show();
      this.$content.css('left', this.widthNav['unclipsed']);
      this.$footer.css('left', this.widthNav['unclipsed']);
      this.$btn.find('span').removeClass('glyphicon-triangle-right')
                            .addClass('glyphicon-triangle-left');

      this._tooltip(false);
    },
    _tooltip: function(handler){
      if(handler) {
        this.$html.find('li a').on('mouseover', function(){
          var $this      = $(this),
              label      = $this.find('.text').text(),
              $tooltip   = $('<div class="tooltip-nav">' + label + '</div>'),
              offset     = $this.offset(),
              thisWidth  = $this[0].offsetWidth,
              thisHeight = $this[0].offsetHeight;

              $tooltip.css({
                top  : offset.top + 8 - $(document).scrollTop() + 'px',
                left : offset.left + thisWidth + 8 + 'px'
              }).appendTo($('body'));

        }).on('mouseleave', function(){
          $('.tooltip-nav').remove();
        });
      } else {
        this.$html.find('li a').off('mouseover');
      }
    },
    init: function(){
      this._clips();
      this._events();
    }
  }

  return ClipsedNav;
})();
